// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { MixedCharts } from '../common/MixedCharts';
// Hooks:
import { useMixedChartsData } from '../../hooks/useMixedChartsData';
// Other
import { useTypedSelector } from '../../redux';

export const Module2Guide1Touch: React.FC = () => {
  const {
    data: { module2guide1timeTouch, module2guide1Touch },
    mode,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const { labelsNames, data1, data2 } = useMixedChartsData(
    mode,
    module2guide1Touch,
    module2guide1timeTouch,
  );

  return (
    <>
      {labelsNames.length > 0 && (
      <MixedCharts
        theme="blue"
        title="Touchscreen Module 2 Drop-out / Harry Boy Guide"
        subtitle="Amount of sessions per view. And session time per view."
        xLabels={labelsNames}
        data1={data1}
        data2={data2}
      />
      )}
    </>
  );
};
